var FormHelper = {
  bind: function($container, data) {
    for (let key in data) {
      if (data.hasOwnProperty(key)) {
        $container.find('[name=' + key + ']').val(data[key]);
      }
    }
  },


  init: function ($form, method, action) {

    $.validator.unobtrusive.parse($form);

    $form.find('input[type=text]').attr('autocomplete', 'off');

    $form.send = function() {
      return new Promise((resolve, reject) => {
        $form.success = resolve;
        $form.error = (ex) => {
          if (ex && ex.data && ex.data.errors) {
            $form.validate().showErrors(ex.data.errors);
          }
          reject();
        }
        $form.submit();
      });
    };

    $form._send = () => {

      const formData = $form.serialize();
      var apiClient = resolve(ApiClient);
      apiClient.send(method, action, formData)
        .then(id => {
          $form.success(id);
        })
        .catch(ex => {
          $form.error(ex);
        });

      //$form.ajaxSubmit({
      //  method: method,
      //  url: action,
      //  success: $form.success,
      //  error: $form.error
      //});
    };

    $form.submit(() => {

        $form.off('change', '.active select.select2');
        $form.on('change', '.active select.select2', function() {
            $(this).valid();
        });

        var $chosen = $form.find('.active .chosen-select-deselect');
        var $select2 = $form.find('.active select.select2');
      //Валидируем форму (+принудительный вызов валидации для скрытых элементов)
        if ($form.valid() & ($chosen.length === 0 || $chosen.valid()) & ($select2.length === 0 || $select2.valid())) {
                $form._send();
      } else {
        $form.error();
      }
      return false;
    });

  }
};
